const KEY_PREFIX = 'vm-qr-session:'
const KEY_STARTED_PREFIX = 'vm-qr-session-started:'
const KEY_WAITPAY_PREFIX = 'vm-qr-session-waitpay:'
const KEY_PAID_PREFIX = 'vm-qr-session-paid:'
const KEY_COMMON_AMOUNTS_PREFIX = 'vm-qr-session-common-amounts:'
const KEY_MPAY_LIST_PREFIX = 'vm-qr-session-mpay-list:'

export function saveSessionId(posMachineCode: string, sessionId: string) {
  try {
    sessionStorage.setItem(KEY_PREFIX + posMachineCode, sessionId)
  } catch {
    /* sessionStorage unavailable */
  }
}

export function loadSessionId(posMachineCode: string): string | null {
  try {
    return sessionStorage.getItem(KEY_PREFIX + posMachineCode)
  } catch {
    return null
  }
}

export function clearSessionId(posMachineCode: string) {
  try {
    sessionStorage.removeItem(KEY_PREFIX + posMachineCode)
    sessionStorage.removeItem(KEY_STARTED_PREFIX + posMachineCode)
    sessionStorage.removeItem(KEY_WAITPAY_PREFIX + posMachineCode)
    sessionStorage.removeItem(KEY_PAID_PREFIX + posMachineCode)
    sessionStorage.removeItem(KEY_COMMON_AMOUNTS_PREFIX + posMachineCode)
    sessionStorage.removeItem(KEY_MPAY_LIST_PREFIX + posMachineCode)
  } catch {
    /* noop */
  }
}

export function saveSessionStartedAt(posMachineCode: string, ts: number) {
  try {
    sessionStorage.setItem(KEY_STARTED_PREFIX + posMachineCode, String(ts))
  } catch {
    /* noop */
  }
}

export function loadSessionStartedAt(posMachineCode: string): number | null {
  try {
    const v = sessionStorage.getItem(KEY_STARTED_PREFIX + posMachineCode)
    return v ? Number(v) : null
  } catch {
    return null
  }
}

export function saveWaitPayStartedAt(posMachineCode: string, ts: number) {
  try {
    sessionStorage.setItem(KEY_WAITPAY_PREFIX + posMachineCode, String(ts))
  } catch {
    /* noop */
  }
}

export function loadWaitPayStartedAt(posMachineCode: string): number | null {
  try {
    const v = sessionStorage.getItem(KEY_WAITPAY_PREFIX + posMachineCode)
    return v ? Number(v) : null
  } catch {
    return null
  }
}

export function savePaidAt(posMachineCode: string, ts: number) {
  try {
    sessionStorage.setItem(KEY_PAID_PREFIX + posMachineCode, String(ts))
  } catch {
    /* noop */
  }
}

export function loadPaidAt(posMachineCode: string): number | null {
  try {
    const v = sessionStorage.getItem(KEY_PAID_PREFIX + posMachineCode)
    return v ? Number(v) : null
  } catch {
    return null
  }
}

/** 常用金額只在 createSession 回傳,存下來讓後續 poll / 重整仍可用於儲值輸入畫面 */
export function saveCommonAmounts(posMachineCode: string, amounts: number[]) {
  try {
    sessionStorage.setItem(
      KEY_COMMON_AMOUNTS_PREFIX + posMachineCode,
      JSON.stringify(amounts),
    )
  } catch {
    /* noop */
  }
}

export function loadCommonAmounts(posMachineCode: string): number[] | null {
  try {
    const v = sessionStorage.getItem(KEY_COMMON_AMOUNTS_PREFIX + posMachineCode)
    if (!v) return null
    const parsed = JSON.parse(v)
    return Array.isArray(parsed) ? parsed.filter((n) => typeof n === 'number') : null
  } catch {
    return null
  }
}

/** 可用支付通路只在 createSession 回傳,存下來讓後續 poll / 重整仍可用於 WAITING_PAY 通路選單 */
export function saveMpayList(posMachineCode: string, list: string[]) {
  try {
    sessionStorage.setItem(KEY_MPAY_LIST_PREFIX + posMachineCode, JSON.stringify(list))
  } catch {
    /* noop */
  }
}

export function loadMpayList(posMachineCode: string): string[] | null {
  try {
    const v = sessionStorage.getItem(KEY_MPAY_LIST_PREFIX + posMachineCode)
    if (!v) return null
    const parsed = JSON.parse(v)
    return Array.isArray(parsed) ? parsed.filter((s) => typeof s === 'string') : null
  } catch {
    return null
  }
}

